import {
  useCallback,
  useMemo,
  useState
} from 'react';
import {
  useAmsSocket
} from './use-ams-socket';

export type UseConcreteAmsSocket = {
  isConnected: boolean;
  connectSocket: (url: string) => void;
  disconnectSocket: () => void;
  subscribe: (handler: (data: any) => void) => () => void;
};

// TODO: refactor me
export const useConcreteAmsSocket = (): UseConcreteAmsSocket => {
  const {
    isConnectedRecords,
    connectSocket: connectSocketByUrl,
    disconnectSocket: disconnectSocketByUrl,
    subscribe: subscribeByUrl,
  } = useAmsSocket();

  const [currentUrl, setCurrentUrl] = useState<string | null>(null);

  const isConnected: boolean = useMemo(() => {
    return currentUrl ? !!isConnectedRecords[currentUrl] : false;
  }, [isConnectedRecords, currentUrl]);

  const connectSocket = useCallback(
    (url: string) => {
      setCurrentUrl(url);
      return connectSocketByUrl(url);
    },
    [connectSocketByUrl]
  );

  const disconnectSocket = useCallback(() => {
    if (currentUrl) {
      disconnectSocketByUrl(currentUrl);
    }
  }, [currentUrl, disconnectSocketByUrl]);

  const subscribe = useCallback(
    (handler: (data: any) => void) => {
      if (!currentUrl) return () => { };
      return subscribeByUrl(currentUrl, handler);
    },
    [currentUrl, subscribeByUrl]
  );

  return {
    isConnected,
    connectSocket,
    disconnectSocket,
    subscribe,
  };
};
